const OKTA_TESTING_DISABLEHTTPSCHECK =
  import.meta.env.VITE_OKTA_TESTING_DISABLEHTTPSCHECK || false;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

export default {
  oidc: {
    clientId: import.meta.env.VITE_CLIENT_ID ?? "",
    issuer: import.meta.env.VITE_ISSUER ?? "",
    redirectUri: REDIRECT_URI,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
};
